import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

interface ButtonConfig {
  text: string;
  action: () => void;
  type?: 'primary' | 'secondary';
}

@Component({
  selector: 'app-baseend-page',
  templateUrl: './baseend-page.component.html',
  styleUrl: './baseend-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush, // Aquí se establece la estrategia OnPush
  encapsulation: ViewEncapsulation.None,
})
export class BaseendPageComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() image: string = '';
  @Input() buttonText: string = '';
  @Input() buttons: ButtonConfig[] = [];
  @Input() isLoaderComponent: boolean = false;
  @Input() extraText: string ="";
  

  getButtonClass(button: ButtonConfig): string {
    const widthClass = this.buttons.length === 1 ? 'btn-single' : 'btn-multiple';
    const typeClass = button.type === 'secondary' ? 'btn-secondary' : 'btn-primary';
    return `${widthClass} ${typeClass}`;
  }

  getImageClass(image: string): string {
    return this.isGif(image) ? 'gif-img' : 'png-img';
  }

  isGif(image: string): boolean {
    return image.endsWith('.gif');
  }

  isPng(image: string): boolean {
    return image.endsWith('.png');
  }

  isWebm(image: string): boolean {
    return image.endsWith('.webm');
  }

  trackByFn(index: number, item: ButtonConfig): number {
    return index;
  }
}
